import { Component, Vue } from 'vue-property-decorator';
import WithRender from './passengers.html';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import _axios from '@/services/axios';
import moment from 'moment';
import VuePhoneNumberInput from "vue-phone-number-input";
import { mapGetters } from 'vuex';
import { BookingType } from '@/types/Booking';
import { CartLine } from '@/types/CartTypes';
import config from '@/settings/config';

@WithRender
@Component({
  filters: {
    formateDate(value: string) {
      return moment(value).format('YYYY-MM-DD HH:mm A')
    }
  },
  components: {
    Loading,
    VuePhoneNumberInput
  },
  computed: {
    ...mapGetters("booking", { booking: "getBooking" }),
    ...mapGetters("originatorStore", { originator: "getOriginator", currency: "getWalletCurrency" })
  }
})
export default class Passengers extends Vue {
  isLoading = false;
  booking!: BookingType;
  capturingForPassenger = 1;
  capturedAllpassenger = false;
  accountNoArr: string[] = [];
  optionTitle = [
    'Mr',
    'Mrs',
    'Miss',
    'Ms',
    'Prof',
    'Dr',
    'Gen',
    'Rep',
    'St',
    'Rev',
    'Other'
  ]
  optionInfant = [
    { value: false, text: 'No' },
    { value: true, text: 'Yes' }
  ]
  valideReceiverFirstNameMessage: string = "";
  valideReceiverSurnameMessage: string = "";

  ValidateDetails(): boolean {
    if ((!this.booking.surname)) {
      this.valideReceiverSurnameMessage = "Recepient Surname is required";
      return false;
    }
    if (!(this.booking.name)) {
      this.valideReceiverFirstNameMessage = "Recepient First name is required";
      return false;
    }
    return true;
  }

  clearFields() {
    this.booking.title = '';
    this.booking.name = '';
    this.booking.surname = '';
    this.booking.contactNumber = '';
    this.booking.emergencyNumber = '';
    this.booking.travelingWithInfant = false;
  }

  async proceed() {
    if (!this.capturedAllpassenger) {
      const dto = {
        fareId: this.booking.fareId,
        dateOfTravel: this.booking.dateOfTravel,
        title: this.booking.title,
        name: this.booking.name,
        surname: this.booking.surname,
        contactNumber: this.booking.contactNumber,
        emergencyNumber: this.booking.emergencyNumber,
        travelingWithInfant: this.booking.travelingWithInfant,
        startingPoint: this.booking.startingPoint,
        destinationPoint: this.booking.destinationPoint,
      }

      if (!this.ValidateDetails()) {
        this.$bvToast.toast('Please make sure you have provided all required details', {
          title: 'Notification',
          variant: 'danger',
          autoHideDelay: 5000,
        })
        return;
      }

      this.isLoading = true;
      try {
        const response = await _axios.post(`${config.gateway}ticket/book`, dto);
        this.accountNoArr.push(response.data);
        if (this.booking.passengerCount == this.capturingForPassenger) {
          await this.$store.dispatch("shoppingCart/addAccountNo", this.accountNoArr.toString());
          this.$router.push(`paymentdetails`);
        }
        else {
          this.capturingForPassenger++;
          this.clearFields();
        }
      } catch (err) {
        console.error(err);
      }finally {
        this.isLoading = false;
      }
    }
  }

  mounted() {
    this.booking.fareId = this.$route.query.trip as string;
    this.booking.dateOfTravel = this.$route.query.date as unknown as Date;
    this.booking.startingPoint = this.$route.query.s as string;
    this.booking.destinationPoint = this.$route.query.d as string;
    this.booking.passengerCount = this.$route.query.p as unknown as number;
  }
}
